<template>
  <b-card>
    <b-card-header>
      <h3>Board &amp; card games under development</h3>
    </b-card-header>
    <b-card-body>
      <b-list-group>
        <b-list-group-item>
          &quot;Heroes&quot; of the Apocalypse <em>(Board Game)</em>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>
    <b-card-footer></b-card-footer>
  </b-card>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      message: "Coming Soon!"
    };
  }
};
</script>